<div class="card mt-4">
  <div class="card-header d-flex justify-content-between align-items-center">
    <div class="col-6">
      <h3 class="card-title">Profiles</h3>
    </div>
    @if (!readonly) {
      <div class="col-6 d-flex justify-content-end">
        <button
          [disabled]="user == null"
          class="btn btn-primary"
          (click)="addNewProfile(getProfiles())"
          >
          Add Profile
        </button>
      </div>
    }
  </div>
  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert
        [type]="alertInfo.type"
        (closed)="alertInfo.show = false"
        >
        {{ alertInfo.message }}
      </ngb-alert>
    }

    <form class="mb-3" [formGroup]="form">
      @for (contact of getProfiles().controls; track contact; let i = $index) {
        <div
          class="d-flex align-items-center mb-2"
          >
          <div class="d-flex flex-column pe-2 col">
            <select-user-profile-field
              [readonly]="readonly || user == null ? true : false"
              [selectFormControl]="getProfileSelect(i)"
              [preloadedOptions]="profileOptions"
              label="Profile"
              />
          </div>
          <div class="d-flex flex-column pe-2 col">
            <select-company-field
              [readonly]="readonly || user == null ? true : false"
              [selectFormControl]="getCompanySelect(i)"
              [preloadedCompanies]="companies"
              label="Company"
              />
          </div>
          @if (!readonly) {
            <div class="pt-5 pb-2">
              <button
                [disabled]="user == null"
                class="btn btn-dark"
                style="padding: 8px 14px"
                (click)="confirmDelete(getProfiles(), i, 'Profile')"
                >
                <i class="fa fa-solid fa-user-times"></i>
              </button>
            </div>
          }
        </div>
      }
    </form>
    @if (!readonly) {
      <div class="text-center mt-4">
        <button
          [disabled]="user == null"
          type="button"
          class="btn btn-success px-4 py-2"
          (click)="submitForm()"
          >
          Save
        </button>
      </div>
    }
  </div>
</div>
